import _ from 'lodash';
import chain from '@ersinfotech/chain';
import {loop, Effects} from 'redux-loop';
import {
  FETCH_SUBJECT,
  FETCH_ALERT_SUBJECT,
  FETCH_SUBJECT_SUCCESS,
  PUSH_SUBJECT_MEMBER,
  REMOVE_SUBJECT_MEMBER,
  UPDATE_SUBJECT_MEMBER_SUCCESS,
  CREATE_SUBJECT_INDEX
} from './actions';

import {
  fetchSubject,
  fetchAlertSubject,
  fetchSubjectLabel,
  pushSubjectMember,
  removeSubjectMember,
  fetchSubjectListCount,
  createSubjectIndex
} from './tasks';

export const initialState = {
  entities: {},
};

export default (state = initialState, action) => {

  if (action.type === CREATE_SUBJECT_INDEX) {
    return loop(
      state,
      Effects.promise(createSubjectIndex, action.subjectId)
    )
  }

  if (action.type === FETCH_SUBJECT) {
    const {id, isAppend, name, subjectId, groupId, isPrivate, isForMember, label, subjectType, limit, offset, parentSubjectId} = action;

    // if (subjectId && _.includes(_.keys(state.entities), subjectId)) return
    //   console.log(subjectId, _.includes(_.keys(state.entities), subjectId));

    // return loop(
    //   state
    // ,
    //   Effects.promise(fetchSubject, {id, ids: subjectId, groupId, isPrivate, isForMember, label, type:subjectType, limit, offset})
    // );
    if (subjectId && _.includes(_.keys(state.entities), subjectId)) {
      return loop(
        state
      ,
        Effects.none()
      );
    } else {
      return loop(
        state
      ,
        Effects.promise(fetchSubject, {id, ids: subjectId, isAppend, name, groupId, isPrivate, isForMember, label, type:subjectType == undefined ? "coding" : subjectType, limit, offset, parentSubjectId})
      );
    }
  };

  if (action.type === FETCH_ALERT_SUBJECT) {
    const {id, isAppend, name, subjectId, groupId, isPrivate, isForMember, label, subjectType, limit, offset} = action;

    // if (subjectId && _.includes(_.keys(state.entities), subjectId)) return
    //   console.log(subjectId, _.includes(_.keys(state.entities), subjectId));

    // return loop(
    //   state
    // ,
    //   Effects.promise(fetchSubject, {id, ids: subjectId, groupId, isPrivate, isForMember, label, type:subjectType, limit, offset})
    // );
    if (subjectId && _.includes(_.keys(state.entities), subjectId)) {
      return loop(
        state
      ,
        Effects.none()
      );
    } else {
      return loop(
        state
      ,
        Effects.promise(fetchAlertSubject, {id, ids: subjectId, isAppend, name, groupId, isPrivate, isForMember, label, type:subjectType, limit, offset})
      );
    }
  };

  if (action.type === FETCH_SUBJECT_SUCCESS) {
    const {id, isAppend, subjects} = action;

    const entities = chain(_.get(subjects, 'data', []))
      .thru(_.map, (subject) => {
        subject.queries = _.keyBy(subject.queries, 'mediaType');
        return subject;
      })
      .thru(_.keyBy, 'id')
      .value();

    let ids = _.map(_.get(subjects, 'data', []), 'id')
    let count = _.get(subjects, 'count', 0)
    return loop({
      ...state,
      entities: {
        ...state.entities,
        ...entities,
      },
      [id]: {
        count: count,
        data: isAppend
          ? [..._.get(state, `${id}.data`), ...ids]
          : ids
      },
    },
      Effects.none()
    );
  };

  if (action.type === PUSH_SUBJECT_MEMBER) {
    return loop(
      state
    ,
      Effects.promise(pushSubjectMember, action.data)
    );
  }

  if (action.type === REMOVE_SUBJECT_MEMBER) {
    return loop(
      state
    ,
      Effects.promise(removeSubjectMember, action.data)
    );
  }

  if (action.type === UPDATE_SUBJECT_MEMBER_SUCCESS) {
    const list = {...state.entities};
    const subject = {...action.data};
    subject.queries = _.keyBy(subject.queries, 'mediaType');
    const id = subject.id;
    list[id] = subject;
    return loop({
      ...state,
      entities: list
    },
      Effects.none()
    )
  }

  return loop(state, Effects.none());
}



/** WEBPACK FOOTER **
 ** ./src/app/modules/subject/reducer.js
 **/